import FinancialTableFooter from './FinancialTableFooter';

export default FinancialTableFooter;
